export default __webpack_public_path__ + "static/media/lal.2cce836f.jpg";